<template>
  <main v-html="faq">
    <!-- <div class="page" id="faq">
      <header class="page-header">
        <h1>よくあるご質問</h1>
      </header>
      <div class="page-content template">
        <section>
          <h2>「もじこ」について教えて下さい</h2>
          <p>「もじこ」とは、音声認識技術を使った「文字起こし専用エディタサービス」です。テレビ・ラジオ業界では日々、多くの文字起こし作業が行われていますが、非常に多くの工数がかかる作業であるため、番組制作の現場にとっては、文字起こしは負担のとても大きな作業です。そんな文字起こしの負担を少しでも減らすために、「もじこ」の開発を行いました。<br>「もじこ」は、どんなに技術が進歩しても音声認識率が100%ではないことに着目して、取材した音声・動画ファイルなどの素材から、IT各社の最新の音声認識AIエンジンを活用してテキスト化を行った後、正しく認識されてない箇所を素早く修正することが可能になるように開発されました。音声認識「AI」エンジンの力と、「人」の力で、短時間かつ高精度な文字起こしを実現する画期的なエディタです。</p>
        </section>
        <section>
          <h2>「もじこ」の受賞歴について教えて下さい</h2>
          <p>「もじこ」は、以下の受賞歴がございます</p>
          <ul>
            <li>2019年 日本民間放送連盟賞 技術部門優秀賞</li>
            <li>2019年 映像情報メディア学会 現場運用部門進歩開発賞</li>
            <li>2019年 日本映画テレビ技術協会 技術開発賞受賞</li>
          </ul>
        </section>
        <section>
          <h2>「もじこ」の料金体系について教えて下さい</h2>
          <p>「もじこ」は、ベースで毎月発生する月額利用料金と文字起こしの素材によって発生する文字起こし料金の合計金額にて、毎月の請求金額を計算しております。</p>
        </section>
        <section>
          <h2>「もじこ」の文字起こし料金はどのように決まりますか？</h2>
          <p>基本的には、文字起こしを行う素材データの長さによる従量課金にて計算します。<br>「もじこ」では、素材データを音声認識エンジンで文字起こしを行う際に、処理時間の短縮を図るためファイルを複数に分割して並列で処理を行います。そのため、素材データの時間数と文字起こし料金の計算に利用する時間数にズレが生じる場合がございます。（素材データによっても異なりますが、理論上、素材データの長さの最大1.5〜2倍程度の時間がかかる想定です。）</p>
        </section>
        <section>
          <h2>「もじこ」にアップロードされた音声データはどのように扱われますか？</h2>
          <p>音声データの扱いは各音声認識エンジンの利用規約に依存しておりますが、「もじこ」では、音声データのログが保存されない音声認識エンジン・プランを採用しています。<br>そのため、弊社ならびに、各音声認識エンジンが音声データを保持する事はありません。（ログアウト時に自動的に削除されます。）</p>
        </section>
        <section>
          <h2>「もじこ」を利用するにあたって、必要なものはありますか？</h2>
          <p>「もじこ」の利用には、ユーザー認証にあたって G Suite のアカウントが必要になります。G Suite を導入されていないお客様は、合わせて G Suite もご導入ください。すでに G Suite を導入されているお客様は、既存の G Suite 環境にて「もじこ」の利用が可能です。<br>※G Suite とは、メール、カレンダー、ドキュメント作成、オンラインストレージ、ビデオ会議などリモートワークに必要な機能が揃った Google が提供する グループウェアです。</p>
        </section>
        <section>
          <h2>G Suite を Google との直接契約または吉積情報株式会社ではない代理店との契約で利用していますが、「もじこ」の利用は可能でしょうか？</h2>
          <p>はい。可能です。すでに G Suite をご利用であれば、契約はそのままで「もじこ」をご利用いただけます。</p>
        </section>
        <section>
          <h2>Office365 で「もじこ」を利用できますか？</h2>
          <p>現在のところ、Office365 では「もじこ」は利用できません。 G Suite アカウントをご利用ください。</p>
        </section>
        <section>
          <h2>「もじこ」のトライアルは可能でしょうか？</h2>
          <p>導入を検討頂いているお客様向けに、14日間の無料トライアルが可能です。</p>
        </section>
        <section>
          <h2>「もじこ」を解約したい場合は、どのような手続きが必要でしょうか？</h2>
          <p>「もじこ」の解約をご希望の場合は、解約希望日の30日前までにお申し出ください。</p>
        </section>
      </div>
    </div> -->
  </main>
</template>

<script>
export default {
  data () {
    return {
      faq: null, // eslint-disable-line
    }
  },
  async beforeMount() {
    const faq = await this.axios.get('/assets/js/faq_test.html').then(r => {
      return r.data
    })
    this.faq = faq
  },
  mounted() {
    //
  },
  methods: {
    //
  },
  computed: {
    //
  },
  apollo: {
    //
  }
}
</script>

<style lang="stylus" scoped>


</style>
